import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TcardsBrandLogo from '../TcardsBrandLogo';
import { TCARDS_HOME_URL } from '../miniwebsite/miniWebsitePaths';
import {
  CONTACT_PATH,
  DOWNLOAD_PATH,
  FIELD_TEAM_SOLUTION_SLUGS,
  LOGIN_SECTION_ID,
  PRICING_SECTION_ID,
  fieldTeamSectionUrl,
  fieldTeamSolutionPath,
} from './fieldTeamRoutes';

type Props = {
  onGetStarted: () => void;
};

export const FieldTeamFooter: React.FC<Props> = ({ onGetStarted }) => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="dcl-footer">
      <div className="dcl-container">
        <div className="dcl-footer-grid">
          <div>
            <TcardsBrandLogo href={TCARDS_HOME_URL} showText size={32} tagline="" />
            <p style={{ margin: '12px 0 0', fontSize: 14, lineHeight: 1.6 }}>
              {t('ftl_footer_blurb')}
            </p>
          </div>
          <div>
            <h4 className="dcl-footer-title">{t('ftl_footer_solutions')}</h4>
            {FIELD_TEAM_SOLUTION_SLUGS.map((slug) => (
              <Link key={slug} to={fieldTeamSolutionPath(slug)} className="dcl-footer-link">
                {t(`ftl_sol_${slug}_nav`)}
              </Link>
            ))}
          </div>
          <div>
            <h4 className="dcl-footer-title">{t('ftl_footer_product')}</h4>
            <Link to={fieldTeamSectionUrl(PRICING_SECTION_ID)} className="dcl-footer-link">{t('ftl_nav_pricing')}</Link>
            <a href={DOWNLOAD_PATH} className="dcl-footer-link">{t('ftl_nav_download')}</a>
            <Link to="/digital-card" className="dcl-footer-link">{t('dcl_nav_digital_card', { defaultValue: 'Digital Card' })}</Link>
          </div>
          <div>
            <h4 className="dcl-footer-title">{t('dcl_footer_company', { defaultValue: 'Company' })}</h4>
            <Link to={CONTACT_PATH} className="dcl-footer-link">{t('ftl_nav_contact')}</Link>
            <Link to="/privacy" className="dcl-footer-link">{t('dcl_footer_privacy', { defaultValue: 'Privacy Policy' })}</Link>
            <Link to="/terms" className="dcl-footer-link">{t('dcl_footer_terms', { defaultValue: 'Terms of Service' })}</Link>
            <h4 className="dcl-footer-title" style={{ marginTop: 20 }}>{t('dcl_footer_account', { defaultValue: 'Account' })}</h4>
            <Link to={fieldTeamSectionUrl(LOGIN_SECTION_ID)} className="dcl-footer-link">{t('ftl_cta_signin')}</Link>
            <button type="button" className="dcl-footer-link" onClick={onGetStarted} style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', textAlign: 'left', width: '100%' }}>
              {t('ftl_cta_signup_free')}
            </button>
          </div>
        </div>
        <div className="dcl-footer-bottom">
          © {year} TCards · {t('dcl_footer_rights', { defaultValue: 'All rights reserved.' })}
        </div>
      </div>
    </footer>
  );
};

export default FieldTeamFooter;
